/* eslint-disable no-unused-vars */
import { create } from 'zustand'

interface UnSavedChangeState {
  hasUnsavedChanges: boolean
  hasBannerChanges: boolean
  hasOtherChanges: boolean
  setHasBannerChanges: (value: boolean) => void
  openDialog: boolean
  targetUrl: string | null
  setHasUnsavedChanges: (value: boolean) => void
  setOpenDialog: (isOpen: boolean, url?: string) => void
  isContinue: boolean
  setIsContinue: (value: boolean) => void
}

export const useUnSavedChangeStore = create<UnSavedChangeState>((set) => ({
  hasUnsavedChanges: false,
  hasBannerChanges: false,
  hasOtherChanges: false,
  openDialog: false,
  isContinue: false,
  targetUrl: null,
  // Banner saves and Appearance saves clear only their own draft's changes.
  setHasUnsavedChanges: (value) =>
    set((state) => ({ hasOtherChanges: value, hasUnsavedChanges: value || state.hasBannerChanges })),
  setHasBannerChanges: (value) =>
    set((state) => ({ hasBannerChanges: value, hasUnsavedChanges: value || state.hasOtherChanges })),
  setOpenDialog: (value, targetUrl = '') => set({ openDialog: value, targetUrl }),
  setIsContinue: (value) => set({ isContinue: value }),
}))
